import { DialogProps } from "@material-ui/core/Dialog";
import * as React from "react";

import { ChipSelectionDialog, IChip, useRelodeApp } from "../";
import { SimpleTagType } from "./types";
import { RelodeApiError, createError, domain } from "../../";

const convertTagsToMatchableChips = (
    tags?: domain.TagMatchType[],
    tagTypes?: SimpleTagType[],
    selectedItems?: IChip[]
) => {
    const chipsTags = {};
    tagTypes &&
        tagTypes.map(tt => {
            chipsTags[tt.id] = [];
        });

    tags &&
        tags.map(tag => {
            if (tag.tagTypeName) {
                const currentType = tag.tagTypeId;
                const values = chipsTags[currentType];

                if (values) {
                    const selectedItem =
                        selectedItems &&
                        selectedItems.find(sItem => sItem.id === tag.tagId);

                    values.push({
                        id: tag.tagId,
                        name: tag.tagName,
                        groupId: tag.tagTypeId,
                        groupName: tag.tagTypeName,
                        isMatched: !!selectedItem,
                        canMatch: true,
                        canEdit: true,
                    });
                    chipsTags[currentType] = values;
                }
            }
        });
    return chipsTags;
};

const convertTagTypesToChips = (tagTypes?: SimpleTagType[]): IChip[] => {
    if (!tagTypes) return [];
    return tagTypes.map(tt => ({
        id: tt.id,
        name: tt.name,
        isMatched: true,
        canEdit: true,
        canMatch: true,
    }));
};

const convertChipsToTags = (chips: IChip[]): domain.TagMatchType[] => {
    const tags: domain.TagMatchType[] = [];
    chips &&
        chips.map(chip => {
            const {
                id,
                name,
                groupId,
                groupName,
                canEdit,
                canMatch,
                isMatched,
            } = chip;
            tags.push({
                tagId: id,
                tagName: name,
                tagTypeId: groupId || -1,
                tagTypeName: groupName || "",
                isMatched,
                canEdit,
                canMatch,
            });
        });
    return tags;
};

type Props = DialogProps & {
    baseId: string;
    tagTypes?: SimpleTagType[];
    open: boolean;
    onClose: () => void;
    onAdd: (selectedTags: domain.TagMatchType[]) => void;
};
export const AddTagsDialog = (props: Props) => {
    const {
        state: {
            config: { tagsLookupService },
        },
    } = useRelodeApp();
    const [suggestions, setSuggestions] = React.useState<domain.TagMatchType[]>(
        []
    );

    const { baseId, onClose, open, tagTypes } = props;
    const extendedId = `${baseId}AddTagsDialog`;

    const lookupTagSuggestion = async (
        searchText: string,
        tagTypeIds: number[],
        selectedItems?: IChip[]
    ) => {
        const newCriteria = { searchText, tagTypeIds };
        try {
            const response = await tagsLookupService.loadSuggestions(
                newCriteria,
                searchText + tagTypeIds?.toString()
            );
            setSuggestions(response);

            return convertTagsToMatchableChips(
                response,
                props.tagTypes,
                selectedItems
            );
        } catch (err) {
            if (err instanceof RelodeApiError) {
                if (err.isAbort() || err.isClientError()) return;
            }
            throw createError(err, "core.AddTagsDialog.lookupTagSuggestion");
        }
    };

    const pruneSelectedTags = (selectedChips: IChip[]) => {
        if (suggestions === undefined) {
            return [];
        } else {
            const selected = selectedChips.filter(c =>
                suggestions.find(s => s.tagId === c.id)
            );
            return selected;
        }
    };

    const onAddTag = (selectedChips: IChip[]) => {
        const selectedTags = convertChipsToTags(selectedChips);
        props.onAdd(selectedTags);
    };

    return open ? (
        <ChipSelectionDialog
            baseId={extendedId}
            closeOnAdd
            open={open}
            chipGroups={convertTagTypesToChips(tagTypes)}
            searchSuggestions={lookupTagSuggestion}
            pruneSelectedChips={pruneSelectedTags}
            onAdd={onAddTag}
            onClose={onClose}
            context="tags"
            // maxWidth={"md"}
        />
    ) : null;
};
